var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDjia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_566)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28_566",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 0H0V28H28V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_28_566)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_28_566",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 4.62H0V23.38H28V4.62Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_28_566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 17.6067H0V19.0492H28V17.6067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 16.1641H0V17.6067H28V16.1641Z",
    fill: "#D20037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 14.7213H0V16.1638H28V14.7213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 19.0493H0V20.4918H28V19.0493Z",
    fill: "#D20037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 21.9374H0V23.38H28V21.9374Z",
    fill: "#D20037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 20.4946H0V21.9372H28V20.4946Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 6.06256H0V7.50512H28V6.06256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 4.62H0V6.06256H28V4.62Z",
    fill: "#D20037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 7.50537H0V8.94793H28V7.50537Z",
    fill: "#D20037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 10.3933H0V11.8359H28V10.3933Z",
    fill: "#D20037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 8.95074H0V10.3933H28V8.95074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 11.8359H0V13.2784H28V11.8359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 13.2787H0V14.7213H28V13.2787Z",
    fill: "#D20037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.243 4.62H0V14.7213H14.243V4.62Z",
    fill: "#002965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.18606 5.10077L1.31822 5.50509H1.74354L1.40026 5.75597L1.53242 6.16281L1.18634 5.91193L0.840263 6.16281L0.972423 5.75597L0.626343 5.50509H1.05418L1.18606 5.10077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0569 5.10077L13.1891 5.50509H13.6144L13.2711 5.75597L13.4033 6.16281L13.0572 5.91193L12.7111 6.16281L12.8433 5.75597L12.5 5.50509H12.9253L13.0575 5.10077H13.0569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6823 5.10077L10.8145 5.50509H11.2423L10.8962 5.75597L11.0284 6.16281L10.6823 5.91193L10.3362 6.16281L10.4684 5.75597L10.1251 5.50509H10.5504L10.6823 5.10077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.30757 5.10077L8.43973 5.50509H8.86757L8.52149 5.75597L8.65365 6.16281L8.30757 5.91193L7.96429 6.16281L8.09645 5.75597L7.75037 5.50509H8.17821L8.30757 5.10077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93573 5.10077L6.06789 5.50509H6.49321L6.14713 5.75597L6.27929 6.16281L5.93573 5.91193L5.58965 6.16281L5.72181 5.75597L5.37573 5.50509H5.80357L5.93573 5.10077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.56082 5.10077L3.69298 5.50509H4.1183L3.77502 5.75597L3.90438 6.16281L3.5611 5.91193L3.21502 6.16281L3.34718 5.75597L3.0011 5.50509H3.42894L3.5611 5.10077H3.56082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.18606 7.11957L1.31822 7.52641H1.74354L1.40026 7.77729L1.53242 8.18161L1.18634 7.93073L0.840263 8.18161L0.972423 7.77729L0.626343 7.52641H1.05418L1.18606 7.11957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0569 7.11957L13.1891 7.52641H13.6144L13.2711 7.77729L13.4033 8.18161L13.0572 7.93073L12.7111 8.18161L12.8433 7.77729L12.5 7.52641H12.9253L13.0575 7.11957H13.0569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6823 7.11957L10.8145 7.52641H11.2423L10.8962 7.77729L11.0284 8.18161L10.6823 7.93073L10.3362 8.18161L10.4684 7.77729L10.1251 7.52641H10.5504L10.6823 7.11957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.30757 7.11957L8.43973 7.52641H8.86757L8.52149 7.77729L8.65365 8.18161L8.30757 7.93073L7.96429 8.18161L8.09645 7.77729L7.75037 7.52641H8.17821L8.30757 7.11957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93573 7.11957L6.06789 7.52641H6.49321L6.14713 7.77729L6.27929 8.18161L5.93573 7.93073L5.58965 8.18161L5.72181 7.77729L5.37573 7.52641H5.80357L5.93573 7.11957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.56082 7.11957L3.69298 7.52641H4.1183L3.77502 7.77729L3.90438 8.18161L3.5611 7.93073L3.21502 8.18161L3.34718 7.77729L3.0011 7.52641H3.42894L3.5611 7.11957H3.56082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.18606 9.13837L1.31822 9.54521H1.74354L1.40026 9.79609L1.53242 10.2029L1.18634 9.95205L0.840263 10.2029L0.972423 9.79609L0.626343 9.54521H1.05418L1.18606 9.13837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0569 9.13837L13.1891 9.54521H13.6144L13.2711 9.79609L13.4033 10.2029L13.0572 9.95205L12.7111 10.2029L12.8433 9.79609L12.5 9.54521H12.9253L13.0575 9.13837H13.0569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6823 9.13837L10.8145 9.54521H11.2423L10.8962 9.79609L11.0284 10.2029L10.6823 9.95205L10.3362 10.2029L10.4684 9.79609L10.1251 9.54521H10.5504L10.6823 9.13837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.30757 9.13837L8.43973 9.54521H8.86757L8.52149 9.79609L8.65365 10.2029L8.30757 9.95205L7.96429 10.2029L8.09645 9.79609L7.75037 9.54521H8.17821L8.30757 9.13837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93573 9.13837L6.06789 9.54521H6.49321L6.14713 9.79609L6.27929 10.2029L5.93573 9.95205L5.58965 10.2029L5.72181 9.79609L5.37573 9.54521H5.80357L5.93573 9.13837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.56082 9.13837L3.69298 9.54521H4.1183L3.77502 9.79609L3.90438 10.2029L3.5611 9.95205L3.21502 10.2029L3.34718 9.79609L3.0011 9.54521H3.42894L3.5611 9.13837H3.56082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.18606 11.1597L1.31822 11.564H1.74354L1.40026 11.8149L1.53242 12.2217L1.18634 11.9708L0.840263 12.2217L0.972423 11.8149L0.626343 11.564H1.05418L1.18606 11.1597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0569 11.1597L13.1891 11.564H13.6144L13.2711 11.8149L13.4033 12.2217L13.0572 11.9708L12.7111 12.2217L12.8433 11.8149L12.5 11.564H12.9253L13.0575 11.1597H13.0569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6823 11.1597L10.8145 11.564H11.2423L10.8962 11.8149L11.0284 12.2217L10.6823 11.9708L10.3362 12.2217L10.4684 11.8149L10.1251 11.564H10.5504L10.6823 11.1597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.30757 11.1597L8.43973 11.564H8.86757L8.52149 11.8149L8.65365 12.2217L8.30757 11.9708L7.96429 12.2217L8.09645 11.8149L7.75037 11.564H8.17821L8.30757 11.1597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93573 11.1597L6.06789 11.564H6.49321L6.14713 11.8149L6.27929 12.2217L5.93573 11.9708L5.58965 12.2217L5.72181 11.8149L5.37573 11.564H5.80357L5.93573 11.1597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.56082 11.1597L3.69298 11.564H4.1183L3.77502 11.8149L3.90438 12.2217L3.5611 11.9708L3.21502 12.2217L3.34718 11.8149L3.0011 11.564H3.42894L3.5611 11.1597H3.56082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.18606 13.1782L1.31822 13.5851H1.74354L1.40026 13.8359L1.53242 14.2403L1.18634 13.9894L0.840263 14.2403L0.972423 13.8359L0.626343 13.5851H1.05418L1.18606 13.1782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0569 13.1782L13.1891 13.5851H13.6144L13.2711 13.8359L13.4033 14.2403L13.0572 13.9894L12.7111 14.2403L12.8433 13.8359L12.5 13.5851H12.9253L13.0575 13.1782H13.0569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6823 13.1782L10.8145 13.5851H11.2423L10.8962 13.8359L11.0284 14.2403L10.6823 13.9894L10.3362 14.2403L10.4684 13.8359L10.1251 13.5851H10.5504L10.6823 13.1782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.30757 13.1782L8.43973 13.5851H8.86757L8.52149 13.8359L8.65365 14.2403L8.30757 13.9894L7.96429 14.2403L8.09645 13.8359L7.75037 13.5851H8.17821L8.30757 13.1782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93573 13.1782L6.06789 13.5851H6.49321L6.14713 13.8359L6.27929 14.2403L5.93573 13.9894L5.58965 14.2403L5.72181 13.8359L5.37573 13.5851H5.80357L5.93573 13.1782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.56082 13.1782L3.69298 13.5851H4.1183L3.77502 13.8359L3.90438 14.2403L3.5611 13.9894L3.21502 14.2403L3.34718 13.8359L3.0011 13.5851H3.42894L3.5611 13.1782H3.56082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8709 12.1688L12.003 12.5757H12.4284L12.0823 12.8265L12.2144 13.2309L11.8712 12.98L11.5251 13.2309L11.6572 12.8265L11.3112 12.5757H11.739L11.8709 12.1688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49624 12.1688L9.6284 12.5757H10.0537L9.71044 12.8265L9.8426 13.2309L9.49652 12.98L9.15044 13.2309L9.2826 12.8265L8.93652 12.5757H9.36436L9.49624 12.1688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12149 12.1688L7.25365 12.5757H7.67897L7.33569 12.8265L7.46785 13.2309L7.12177 12.98L6.77569 13.2309L6.90785 12.8265L6.56177 12.5757H6.98961L7.12149 12.1688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7469 12.1688L4.87906 12.5757H5.3069L4.96082 12.8265L5.09298 13.2309L4.7469 12.98L4.40082 13.2309L4.53298 12.8265L4.1897 12.5757H4.61502L4.74718 12.1688H4.7469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.37214 12.1688L2.5043 12.5757H2.93214L2.58606 12.8265L2.71822 13.2309L2.37214 12.98L2.02886 13.2309L2.16102 12.8265L1.81494 12.5757H2.24278L2.37214 12.1688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8709 10.1503L12.003 10.5546H12.4284L12.0823 10.8055L12.2144 11.2123L11.8712 10.9614L11.5251 11.2123L11.6572 10.8055L11.3112 10.5546H11.739L11.8709 10.1503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49624 10.1503L9.6284 10.5546H10.0537L9.71044 10.8055L9.8426 11.2123L9.49652 10.9614L9.15044 11.2123L9.2826 10.8055L8.93652 10.5546H9.36436L9.49624 10.1503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12149 10.1503L7.25365 10.5546H7.67897L7.33569 10.8055L7.46785 11.2123L7.12177 10.9614L6.77569 11.2123L6.90785 10.8055L6.56177 10.5546H6.98961L7.12149 10.1503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7469 10.1503L4.87906 10.5546H5.3069L4.96082 10.8055L5.09298 11.2123L4.7469 10.9614L4.40082 11.2123L4.53298 10.8055L4.1897 10.5546H4.61502L4.74718 10.1503H4.7469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.37214 10.1503L2.5043 10.5546H2.93214L2.58606 10.8055L2.71822 11.2123L2.37214 10.9614L2.02886 11.2123L2.16102 10.8055L1.81494 10.5546H2.24278L2.37214 10.1503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8709 8.12897L12.003 8.53581H12.4284L12.0823 8.78669L12.2144 9.19353L11.8712 8.94265L11.5251 9.19353L11.6572 8.78669L11.3112 8.53581H11.739L11.8709 8.12897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49624 8.12897L9.6284 8.53581H10.0537L9.71044 8.78669L9.8426 9.19353L9.49652 8.94265L9.15044 9.19353L9.2826 8.78669L8.93652 8.53581H9.36436L9.49624 8.12897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12149 8.12897L7.25365 8.53581H7.67897L7.33569 8.78669L7.46785 9.19353L7.12177 8.94265L6.77569 9.19353L6.90785 8.78669L6.56177 8.53581H6.98961L7.12149 8.12897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7469 8.12897L4.87906 8.53581H5.3069L4.96082 8.78669L5.09298 9.19353L4.7469 8.94265L4.40082 9.19353L4.53298 8.78669L4.1897 8.53581H4.61502L4.74718 8.12897H4.7469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.37214 8.12897L2.5043 8.53581H2.93214L2.58606 8.78669L2.71822 9.19353L2.37214 8.94265L2.02886 9.19353L2.16102 8.78669L1.81494 8.53581H2.24278L2.37214 8.12897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8709 6.11017L12.003 6.51701H12.4284L12.0823 6.76789L12.2144 7.17221L11.8712 6.92133L11.5251 7.17221L11.6572 6.76789L11.3112 6.51701H11.739L11.8709 6.11017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49624 6.11017L9.6284 6.51701H10.0537L9.71044 6.76789L9.8426 7.17221L9.49652 6.92133L9.15044 7.17221L9.2826 6.76789L8.93652 6.51701H9.36436L9.49624 6.11017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12149 6.11017L7.25365 6.51701H7.67897L7.33569 6.76789L7.46785 7.17221L7.12177 6.92133L6.77569 7.17221L6.90785 6.76789L6.56177 6.51701H6.98961L7.12149 6.11017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7469 6.11017L4.87906 6.51701H5.3069L4.96082 6.76789L5.09298 7.17221L4.7469 6.92133L4.40082 7.17221L4.53298 6.76789L4.1897 6.51701H4.61502L4.74718 6.11017H4.7469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.37214 6.11017L2.5043 6.51701H2.93214L2.58606 6.76789L2.71822 7.17221L2.37214 6.92133L2.02886 7.17221L2.16102 6.76789L1.81494 6.51701H2.24278L2.37214 6.11017Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6827 18.4484C25.6827 20.4532 23.7868 22.0786 21.448 22.0786C20.5906 22.0786 19.7926 21.8602 19.1257 21.4844C17.9737 20.8357 17.2133 19.7182 17.2133 18.4484C17.2133 16.4433 21.448 12.9503 21.448 12.9503C21.448 12.9503 22.1245 13.5084 22.937 14.3066C24.1567 15.505 25.6827 17.2447 25.6827 18.4484Z",
    fill: "#F9D953"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6827 18.4484C25.6827 20.4532 23.7868 22.0786 21.448 22.0786C20.5906 22.0786 20.025 21.9811 19.358 21.6056C19.652 21.7627 20.2526 21.793 20.9736 21.7764C22.6077 21.7389 24.2132 20.235 24.1749 18.3546C24.1474 17.0069 23.3508 15.5968 22.606 14.415C22.5072 14.3976 22.5008 14.3615 22.4943 14.3256C22.6419 14.3102 22.7894 14.3046 22.937 14.3063C24.1567 15.5047 25.6827 17.2446 25.6827 18.4484Z",
    fill: "#E0B12B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8472 14.2111L18.296 12.2231C18.296 12.2231 18.5951 12.1069 18.9941 12.1601C19.3891 12.2128 19.304 12.3657 19.6767 12.3917C20.0287 12.4166 20.0939 11.9966 20.5035 11.9966C20.9132 11.9966 21.1142 12.3917 21.467 12.3917C21.8198 12.3917 21.9231 12.0229 22.3317 11.9966C22.7108 11.9723 22.7931 12.4595 23.2571 12.4295C23.4923 12.4144 23.6376 12.1951 23.8943 12.1181C24.3485 11.9818 24.6442 12.1475 24.6226 12.1487L23.1017 14.2223L19.8475 14.2109L19.8472 14.2111Z",
    fill: "#F9D953"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1053 14.2263L24.6223 12.1486C24.6528 12.1355 24.281 12.0042 23.9433 12.1069L22.5741 14.2263H23.1053Z",
    fill: "#E0B12B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1411 14.0958H19.7548C19.6236 14.0958 19.5173 14.2021 19.5173 14.3332V14.3573C19.5173 14.4884 19.6236 14.5947 19.7548 14.5947H23.1411C23.2722 14.5947 23.3785 14.4884 23.3785 14.3573V14.3332C23.3785 14.2021 23.2722 14.0958 23.1411 14.0958Z",
    fill: "#A06E00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3763 20.4008C21.0126 20.4008 20.6959 20.3448 20.4269 20.2328C20.1575 20.1211 19.9478 19.9551 19.7974 19.7353C19.6471 19.5155 19.5678 19.245 19.5597 18.9233H20.4649C20.4773 19.0759 20.5229 19.2036 20.6021 19.3063C20.6814 19.4091 20.7869 19.4861 20.9191 19.5368C21.0513 19.5877 21.2005 19.6132 21.3671 19.6132C21.5337 19.6132 21.6785 19.5894 21.8014 19.5415C21.9243 19.4936 22.0203 19.4262 22.0895 19.3385C22.1587 19.2512 22.1931 19.1492 22.1931 19.0333C22.1931 18.9294 22.162 18.8424 22.1001 18.7724C22.038 18.7021 21.9492 18.6416 21.8333 18.5906C21.7174 18.54 21.5763 18.4952 21.4097 18.4562L20.9099 18.3311C20.5257 18.2376 20.225 18.0906 20.0074 17.8901C19.7901 17.6896 19.6812 17.4247 19.6812 17.0949C19.6812 16.8202 19.7549 16.5802 19.9021 16.3744C20.0494 16.1689 20.2516 16.0093 20.5089 15.8951C20.7659 15.7811 21.0591 15.7243 21.3884 15.7243C21.7238 15.7243 22.0164 15.7817 22.2662 15.8968C22.5162 16.0116 22.7111 16.1714 22.8514 16.3758C22.9917 16.5805 23.0636 16.816 23.0678 17.0826H22.1685C22.1522 16.8994 22.0747 16.758 21.9352 16.6584C21.7961 16.5587 21.6107 16.5088 21.3789 16.5088C21.2223 16.5088 21.0882 16.5312 20.9765 16.576C20.8648 16.6208 20.7799 16.683 20.722 16.7622C20.664 16.8415 20.6352 16.9322 20.6352 17.0338C20.6352 17.1458 20.6688 17.2388 20.7357 17.3133C20.8026 17.3875 20.8922 17.4477 21.0039 17.4933C21.1157 17.5392 21.2347 17.5773 21.3607 17.6078L21.7723 17.7086C21.9632 17.7515 22.141 17.8094 22.3057 17.8825C22.4703 17.9559 22.6145 18.0458 22.7385 18.1527C22.8623 18.2597 22.9583 18.3862 23.0267 18.5327C23.0947 18.6791 23.1289 18.8482 23.1289 19.0395C23.1289 19.3142 23.0597 19.5538 22.9217 19.7582C22.7833 19.9629 22.5834 20.1211 22.3211 20.2328C22.059 20.3446 21.7443 20.4008 21.3763 20.4008ZM21.1904 20.9471V15.1721H21.5561V20.9471H21.1904Z",
    fill: "#A06E00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjia);
export default __webpack_public_path__ + "static/media/DJIA.0beefe0b7945ac034d3ddf2700b592c2.svg";
export { ForwardRef as ReactComponent };